module.exports = __webpack_public_path__ + "static/media/gradphoto.f7944da9.jpeg";